import {
  ADD_FAQ,
  EDIT_FAQ,
  GET_FAQS,
  REMOVE_FAQ,
  GET_FAQ_BY_ID,
} from "../actions/faq-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const faqReducer = (state = initialState, action: any): ApiRequestState => {
  switch (action.type) {
    case (ADD_FAQ.REQUEST,
    GET_FAQS.REQUEST,
    GET_FAQ_BY_ID.REQUEST,
    EDIT_FAQ.REQUEST,
    REMOVE_FAQ.REQUEST):
      return {
        ...state,
        loading: true,
        error: null,
      };
    case (ADD_FAQ.SUCCESS,
    GET_FAQS.SUCCESS,
    GET_FAQ_BY_ID.SUCCESS,
    EDIT_FAQ.SUCCESS,
    REMOVE_FAQ.SUCCESS):
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case (ADD_FAQ.FAILURE,
    GET_FAQS.FAILURE,
    GET_FAQ_BY_ID.FAILURE,
    EDIT_FAQ.FAILURE,
    REMOVE_FAQ.FAILURE):
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { faqReducer };
